import React, { Fragment, useState, useEffect } from 'react';
import { Image, Button, Modal, Table } from 'react-bootstrap';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import moment from 'moment';
import SuperAdminCall from '../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall';
import SuperAdminSMS from '../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS';
import SuperAdminNotification from '../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification';
import SuperAdminFlag from '../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag';
import SuperAdminBlockUser from '../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser';
import { SuperAdminVendorViewDetailsPopup } from '../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminVendorViewDetailsPopup';
import ApprovedModelPopup from '../ApprovedModelPopup';
import OnHoldPendingModel from '../OnHoldPendingModel';
import isEmpty from '../../../../../../store/validation/is-Empty';
import PendingAddRatingReview from '../PendingAddRatingReview';
import AdminTwilioCallingPopup from '../../AdminTwilioCallingPopup';
import QRCodeMerchants from '../../../../../reusableComponents/QRCodePrintAndExport/QRCodeMerchants';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const AllVendorTableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  useEffect(() => {
    // console.log(props);
    if (props?.index === 0 && props?.setDataForPagination && props?.wholeData) {
      props.setDataForPagination(props.wholeData);
      props.setDataWhole(props.sendData);
    }
  }, [props?.index]);

  return (
    <Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr className="sd_body_table-row" onClick={showTr}>
                  <td style={{ width: '12%' }}>
                    <div className="vendor-main-section-one text-break">
                      <div className="Image-box-section">
                        <Image
                          fluid
                          alt="Restaurant Photo"
                          title="Restaurant Photo"
                          src={props.vendorData.logo_url}
                        />
                      </div>
                      <h5 className="font_16_m mt-2">
                        #
                        {props.vendorData._id.substr(
                          props.vendorData._id.length - 15
                        )}
                      </h5>
                    </div>
                  </td>
                  <td style={{ width: '14%' }} className="text-break">
                    <h3 className="font_20_m">
                      {props.vendorData.restaurant_name}
                    </h3>
                  </td>
                  <td style={{ width: '18%' }}>
                    {!isEmpty(props.vendorData.primary_detail) && (
                      <React.Fragment>
                        <div className="font_18_m d-flex">
                          {props.vendorData.primary_detail.firstName +
                            ' ' +
                            props.vendorData.primary_detail.lastName}
                        </div>
                        {!isEmpty(
                          props.vendorData.primary_detail.enquiry_emails
                        ) &&
                          props.vendorData.primary_detail.enquiry_emails.map(
                            (email, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <div
                                    className="font_18_m mb-2 mt-2 text-lowercase"
                                    style={{ wordBreak: 'break-word' }}
                                  >
                                    {email}
                                  </div>
                                </React.Fragment>
                              );
                            }
                          )}
                        {!isEmpty(
                          props.vendorData.primary_detail.phone_numbers
                        ) &&
                          props.vendorData.primary_detail.phone_numbers.map(
                            (phone, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <div className="font_18_m">
                                    {phone.country_code + ' ' + phone.mobile_no}
                                  </div>
                                </React.Fragment>
                              );
                            }
                          )}
                      </React.Fragment>
                    )}
                  </td>
                  <td style={{ width: '16%' }}>
                    <div className="font_18_r">
                      {props.vendorData.restaurant_address}
                    </div>
                  </td>
                  <td style={{ width: '10%', textAlign: 'center' }}>
                    <div className="progressCircleTbl">
                      <CircularProgressbar
                        value={Math.round(
                          (props.vendorData.page_completed_till / 21) * 100
                        )}
                        text={`${Math.round(
                          (props.vendorData.page_completed_till / 21) * 100
                        )}%`}
                        styles={buildStyles({
                          pathColor: `#FEC32D`,
                          textColor: 'gray',
                          trailColor: '#d6d6d6',
                          backgroundColor: '#3e98c7',
                        })}
                      />
                    </div>
                    <div className="font_18_m mt-3">
                      {props.vendorData.softOnboarding ? 'Soft Onboarded' : ''}
                    </div>
                  </td>
                  <td style={{ width: '12%' }}>
                    <div className="font_18_m">
                      {props.vendorData.primary_restaurant_type.length !== 0
                        ? props.vendorData.primary_restaurant_type[0].title
                        : ''}
                    </div>
                    <div className="font_18_r">
                      {props.vendorData.primary_cusine.length !== 0
                        ? props.vendorData.primary_cusine[0].title
                        : ''}
                    </div>
                    <div className="w-75">
                      <hr />
                      <div className="font_18_r d-flex justify-content-between">
                        <img
                          className="organic-image"
                          src={
                            props.vendorData.primary_food_type.length !== 0
                              ? props.vendorData.primary_food_type[0].icon
                              : require('./../../../../../../assets/images/superadmin/marilend.png')
                          }
                          alt="type"
                        />
                        {props.vendorData.primary_food_type.length !== 0
                          ? props.vendorData.primary_food_type[0].title
                          : ''}
                      </div>
                    </div>
                  </td>
                  {props.displayStatus === true ? (
                    <td style={{ width: '8%' }}>Cell</td>
                  ) : null}
                  <td
                    style={
                      props.displayStatus === true
                        ? { width: '12%' }
                        : { width: '18%' }
                    }
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <OnHoldPendingModel data={props.vendorData} />
                      {props.vendorData && !props.vendorData.vendor.onHold ? (
                        <ApprovedModelPopup data={props.vendorData.vendor_id} />
                      ) : (
                        <button
                          className="n_button_d_status font_18_m popup-save-button"
                          style={{ opacity: 0.3 }}
                          type="button"
                        >
                          Approves
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <>
                    <tr className="sd_accordion_body">
                      <td style={{ width: '26%' }}>
                        <h5 className="font_18_b mb-3">Contact</h5>
                        <div className="d-flex align-items-center">
                          {/* <SuperAdminCall sendData={props.vendorData} /> */}
                          <AdminTwilioCallingModal
                            sendData={props.vendorData.point_of_contact}
                          />
                          {/* <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={props.openChatWindow}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/forum.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button> */}
                          <SuperAdminSMS dataSend={props.vendorData} />
                          <SuperAdminNotification dataSend={props.vendorData} />
                        </div>
                      </td>
                      <td style={{ width: '20%' }}>
                        <div className="font_18_b mb-4">Hours of Operation</div>
                        <h5 className="font_18_r">
                          Closes: {moment().format('HH : mm A')}
                        </h5>
                      </td>
                      <td style={{ width: '7%' }}>
                        <div className="font_18_b mb-4">City</div>
                        <h5 className="font_18_r">{props.vendorData.city}</h5>
                      </td>
                      <td style={{ width: '13%' }}>
                        <div className="font_18_b mb-4">Location</div>
                        <h5 className="font_18_r">{props.vendorData.area}</h5>
                      </td>
                      <td style={{ width: '10%' }}>
                        <div className="font_18_b mb-4">Member Since</div>
                        <h5 className="font_18_r">
                          {moment(props.vendorData.createdAt).format(
                            'DD/MM/YYYY'
                          )}
                        </h5>
                      </td>
                      <td style={{ width: '24%' }}>
                        <h5 className="font_18_b c_red mb-3">More Actions</h5>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="link"
                            className="enIconBtn mr-3 action_icon_padding"
                            onClick={props.handleProfileClick}
                          >
                            <Image
                              src={require('../../../../../../assets/images/ActionImages/image/profile.svg')}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <SuperAdminFlag data={props.vendorData} />
                          <SuperAdminBlockUser
                            data={props.vendorData}
                            actionCall={'pending'}
                          />
                          <SuperAdminVendorViewDetailsPopup
                            viewData={props.vendorData}
                          />
                          <PendingAddRatingReview data={props.vendorData} />
                        </div>
                      </td>
                    </tr>
                    <tr className="border-top sd_accordion_body">
                      <td style={{ width: '15%' }}>
                        <div className="font_18_b mb-4">Services Offered</div>
                        <h5 className="font_18_r">
                          {props?.vendorData?.selected_services_offered
                            .length <= 0
                            ? '-'
                            : props?.vendorData?.selected_services_offered.map(
                                (item, index) => {
                                  if (index === 0) {
                                    return item.title;
                                  } else if (item.title) {
                                    return ', ' + item.title;
                                  }
                                }
                              )}
                        </h5>
                      </td>
                      <td style={{ width: '15%' }}>
                        <div className="font_18_b mb-4">Located Inside</div>
                        <h5 className="font_18_r">
                          {props?.vendorData?.selected_located_inside.length <=
                          0
                            ? '-'
                            : props?.vendorData?.selected_located_inside.map(
                                (item, index) => {
                                  if (index === 0) {
                                    return item.title;
                                  } else if (item.title) {
                                    return ', ' + item.title;
                                  }
                                }
                              )}
                        </h5>
                      </td>
                      <td style={{ width: '15%' }}>
                        <div className="font_18_b mb-4">Liquor</div>
                        <h5 className="font_18_r">
                          {props?.vendorData?.selected_liquor_category.length <=
                          0
                            ? '-'
                            : props?.vendorData?.selected_liquor_category.map(
                                (item, index) => {
                                  if (index === 0) {
                                    return item.title;
                                  } else if (item.title) {
                                    return ', ' + item.title;
                                  }
                                }
                              )}
                        </h5>
                      </td>
                      <td style={{ width: '15%' }}>
                        <div className="font_18_b mb-4">Cuisines</div>
                        <h5 className="font_18_r">
                          {props?.vendorData?.selected_cusine.length <= 0
                            ? '-'
                            : props?.vendorData?.selected_cusine.map(
                                (item, index) => {
                                  if (index === 0) {
                                    return item.title;
                                  } else if (item.title) {
                                    return ', ' + item.title;
                                  }
                                }
                              )}
                        </h5>
                      </td>
                      <td style={{ width: '15%' }}>
                        <div className="font_18_b mb-4">Subscription</div>
                        <h5 className="font_18_r">
                          {props.vendorData &&
                          props.vendorData.casual_dining &&
                          props.vendorData.casual_dining ? (
                            <React.Fragment>
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.listing
                                ? 'Listing Service, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.offer_management
                                ? 'Offer, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.scan_and_pay
                                ? 'Scan and Pay, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.event_management
                                ? 'Event, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.live_streaming
                                ? 'Live Streaming, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.seating
                                ? 'Seating, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.ordering
                                ? 'Ordering, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.menu_setup
                                ? 'Menu Setup, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining.voice_services
                                ? 'Voice Services, '
                                : ''}
                              {props.vendorData &&
                              props.vendorData.casual_dining &&
                              props.vendorData.casual_dining
                                .manage_staff_licence
                                ? 'Manage Staff'
                                : ''}
                            </React.Fragment>
                          ) : props.vendorData &&
                            props.vendorData.fast_food_dining &&
                            props.vendorData.fast_food_dining ? (
                            <React.Fragment>
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.listing
                                ? 'Listing Service'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.offer_management
                                ? 'Offer'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.scan_and_pay
                                ? 'Scan and Pay'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.live_streaming
                                ? 'Live Streaming'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.ordering
                                ? 'Ordering'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.menu_setup
                                ? 'Menu Ssetup'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining.voice_services
                                ? 'Voice Services'
                                : ''}
                              {props.vendorData &&
                              props.vendorData.fast_food_dining &&
                              props.vendorData.fast_food_dining
                                .manage_staff_licence
                                ? 'Manage Staff'
                                : ''}
                            </React.Fragment>
                          ) : (
                            '-'
                          )}
                        </h5>
                      </td>
                      <td style={{ width: '30%' }}>
                        <div className="font_18_b mb-4"> QR code Setup</div>
                        <QRCodeMerchants
                          door_front={{
                            restaurantId: props.vendorData._id,
                          }}
                          restaurantId={props.vendorData._id}
                          referral_data={
                            props?.vendorData?.vendor?.shareLink
                              ?.userShortLink || ''
                          }
                          table_management_data={
                            {
                              ...props.vendorData?.casual_dining
                                ?.table_management?.table_setup,
                              type: 'table_management',
                              vendor_id: props.vendorData?.vendor_id,
                              restaurant_id: props.vendorData._id,
                            } || {
                              ...props.vendorData?.fast_food_dining
                                ?.table_management?.table_setup,
                              type: 'table_management',
                              vendor_id: props.vendorData?.vendor_id,
                              restaurant_id: props.vendorData._id,
                            } || {
                              ...props.vendorData?.multi_service_business
                                ?.table_management?.table_setup,
                              type: 'table_management',
                              vendor_id: props.vendorData?.vendor_id,
                              restaurant_id: props.vendorData._id,
                            }
                          }
                          table_management_status={
                            props.vendorData?.casual_dining?.table_management
                              ?.value ||
                            props.vendorData?.fast_food_dining?.table_management
                              ?.value ||
                            props.vendorData?.multi_service_business
                              ?.table_management?.value
                          }
                        />
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

export const AdminTwilioCallingModal = (props) => {
  const [callingModal, setCallingModal] = useState(false);
  const onOpenModal = () => {
    setCallingModal(true);
  };
  const onCloseModal = () => {
    setCallingModal(false);
  };

  return (
    <React.Fragment>
      <Button variant="link" className="enIconBtn mr-3" onClick={onOpenModal}>
        <Image
          src={require('../../../../../../assets/images/UserManagement/phone.svg')}
          alt="Call"
          title="Call"
          fluid
        />
      </Button>
      <Modal
        show={callingModal}
        onHide={onCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>User Contact List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 p-0 user-table-reusable-superadmin">
            <Table className="HideShowTable">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th style={{ width: '7.5%' }} className="f12-700">
                    SR No.
                  </th>
                  <th style={{ width: '12.5%' }} className="f12-700">
                    Profile Photo
                  </th>
                  <th style={{ width: '11.5%' }} className="f12-700">
                    First Name
                  </th>
                  <th style={{ width: '11.5%' }} className="f12-700">
                    Last Name
                  </th>
                  <th style={{ width: '20.5%' }} className="f12-700">
                    Email
                  </th>
                  <th style={{ width: '18%' }} className="f12-700">
                    Number
                  </th>
                  <th style={{ width: '18.5%' }} className="f12-700">
                    Position
                  </th>
                </tr>
              </thead>
              {!isEmpty(props.sendData) &&
                props?.sendData.map((data, index) => {
                  return (
                    <tbody
                      style={{
                        lineBreak: 'anywhere',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        boxShadow: '0px 3px 6px #00000014',
                        padding: '10px 0px',
                      }}
                      key={index}
                    >
                      <tr>
                        <td style={{ width: '7.5%' }} className="f10-400">
                          {++index}
                        </td>
                        <td style={{ width: '12.5%' }} className="f10-400">
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              <Image
                                src={data.photo_thumbnails}
                                className="img-fluid rounded w-50"
                                alt="User"
                                title="User"
                              />
                            </SRLWrapper>
                          </SimpleReactLightbox>
                        </td>
                        <td style={{ width: '11.5%' }} className="f10-400">
                          {data.firstName}
                        </td>
                        <td style={{ width: '11.5%' }} className="f10-400">
                          {data.lastName}
                        </td>
                        <td style={{ width: '20.5%' }} className="f10-400">
                          {!isEmpty(data.enquiry_emails) &&
                            data?.enquiry_emails.map((data, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <p className="mb-2">{data}</p>
                                </React.Fragment>
                              );
                            })}
                        </td>
                        <td style={{ width: '18%' }} className="f10-400">
                          {!isEmpty(data.phone_numbers) &&
                            data?.phone_numbers.map((number, index) => {
                              return (
                                <div
                                  className="mb-3 d-flex align-items-center w-100"
                                  key={index}
                                >
                                  <p className="mr-3">
                                    {number.country_code + number.mobile_no}
                                  </p>
                                  <AdminTwilioCallingPopup
                                    allData={data}
                                    sendData={number}
                                  />
                                </div>
                              );
                            })}
                        </td>
                        <td style={{ width: '18.5%' }} className="f10-400">
                          {data.selected_position}
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
